<template>
  <div class="col d-column">
    <div class="card-search">
      <div class="row">
        <div class="col-12 col-md-6 py-2">
          <div class="input-group"> 
            <b-form-datepicker 
              class="datepicker m-0 p-0 mr-2"
              id=""
              label-help=""
              :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
              :locale="$ml.get('ln')"
              today-button
              reset-button
              close-button
              :label-today-button="$ml.get('today')"
              :label-reset-button="$ml.get('reset')"
              :label-close-button="$ml.get('exit')"
              v-model="initialDate"
              :placeholder="$ml.get('start')" >
            </b-form-datepicker> 
             
          </div>   
        </div>

        <div class="col-12 col-md-6 py-2"> 
          <div class="input-group"> 
            <b-form-datepicker 
              class="datepicker m-0 p-0 mr-2"
              id=""
              label-help=""
              :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
              :locale="$ml.get('ln')"
              today-button
              reset-button
              close-button
              :label-today-button="$ml.get('today')"
              :label-reset-button="$ml.get('reset')"
              :label-close-button="$ml.get('exit')"
              v-model="finalDate"
              :placeholder="$ml.get('end')" >
            </b-form-datepicker> 
          </div>  
        </div>

        <div class="col-12 col-md-6 py-2">
          <div class="mr-2">
            <multiselect v-model="status" label="name" :custom-label="nameLang" :options="itensSituation"
              :searchable="false" :close-on-select="true" :show-labels="false"
              @input="changeDados()" :placeholder="$ml.get('select')">
            </multiselect>
          </div>
        </div>
        <div class="input-group col-12 col-md-6 py-2">
          <input class="form-control filterInput" v-model="paymentsQuerySearch" :placeholder="$ml.get('search')"
            aria-label="Search" style="border-right: none" @input="searchTime()" />
          <div class="input-group-append mr-2">
            <div class="input-group-text" style="background-color: #fff">
              <svg width="20" height="20" class="mt-1">
                <image xlink:href="../../../assets/icons/search_s.svg" width="18" height="18" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
    <table>
      <thead>
        <tr>
          <th class="col-3" v-text="$ml.get('dateTime')"></th>
          <th class="col-8" v-text="$ml.get('description')"></th>
          <th class="col-3" v-text="$ml.get('value')"></th>
          <th class="col-7" v-text="$ml.get('v_pending_retest')"></th>
          <th class="col-3" v-text="$ml.get('status')"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-show="!itensPayment.length" class="loading">
          <div v-if="loading" class="c-loader m-3"></div>
          <h6 v-else class="col d-flex justify-content-center p-3" v-text="$ml.get('noPaymentsFound')">
            Nenhum pagamento encontrado
          </h6>
        </tr>
        <tr v-for="(item, index) in itensPayment" :key="index">
          <td class="col-3 font-14 d-flex align-items-center">
            {{ $utils.formatDataLong(item.createdAt) }}<br />
          </td>
          <td class="col-8 d-flex align-items-center">
            <div>
              <span class="text-muted small"><span v-text="$ml.get('specialist')"></span>
                <a class="text-primary">: {{ item.hacker_username }}</a><br />
              </span>
  
              <span class="text-muted small"><span v-text="$ml.get('program')"></span>
                <a class="text-primary">: {{ item.program }}</a><br />
              </span>
  
              <span class="text-muted small"><span v-text="$ml.get('report')"></span>
              <router-link class="text-primary" :to="'/report/details?' + item.report_id">
                  : {{ item.report_id }}
                </router-link>
               </span> <br />
  
              <span class="text-muted small"><span v-text="$ml.get('title')"></span>
                <a class="text-primary">: {{ item.report_title }}</a><br />
              </span>
            </div>
          </td>
 
          <td class="col-3 font-14 d-flex align-items-center">
            <div>
              <span>{{ convertMoney(item.bounty_value) }}</span>
            </div>
          </td>

          <td class="col-7 d-flex align-items-center"> 
            <div class="">
              <div class="my-1" v-for="(itemRetest, index) in item.report_retest_payment" :key="index">
                <span class="text-muted small" ><span> ID</span>
                  <a class="text-primary">: {{itemRetest._id}}</a><br />
                </span>
                <span class="text-muted small" ><span v-text="$ml.get('value')"></span>
                  <a class="text-primary">: {{convertMoney(itemRetest.retest_value)}}</a><br />
                </span>
              </div> 
            </div>
          </td>

          <td class="col-3 d-flex justify-content-start align-items-center">
            <div>
              <span v-show="item.status == 'pending'" class="badge badge-warning p-1"
                v-text="$ml.get('pending')">Pendente</span>
              <span v-show="item.status == 'done'" class="badge badge-success p-1"
                v-text="$ml.get('done')">Pago</span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <div v-show="totalPages > 10 && itensPayment.length" class="p-3">
      <b-pagination v-model="pageActive" :total-rows="totalPages" :per-page="pageSize"
        :prev-text="$ml.get('previous')" :next-text="$ml.get('next')" align="right">
      </b-pagination>
    </div> 
  </div>
 
</template>

<script>
import CompanyService from "../../../services/company.service";
  
export default {
  name: "payment",
 
  data() {
    return {
      pageActive: 1,
      pageSize: 10,
      totalPages: 0,
      initialDate: "",
      finalDate: "",
      status: null,
      itensPayment: [],
      loading: true,
      paymentsQuerySearch: "",

      itensSituation: [
        { id: "all", name: "all" },
        { id: "done", name: "done" },
        { id: "pending", name: "pending" },
      ],
    };
  },
  watch: {
    initialDate: function () {
      this.dataOrder();
    },
    finalDate: function () {
      this.dataOrder();
    },
    pageActive: function () {
      this.changeDados();
    },
  },
  mounted() {
    this.changeDados();
  },
  methods: {
    nameLang({ name }) {
      return `${this.$ml.get(name)}`;
    },

    dataOrder() {
      var first = this.initialDate;
      var end = this.finalDate;

      if ( first  &&  end) {
        first = first.split("/");
        end = end.split("/");

        first = new Date(first[1] + "-" + first[0] + "-" + first[2]);
        end = new Date(end[1] + "-" + end[0] + "-" + end[2]);

        if (first > end) {
          let invert = this.initialDate;
          this.initialDate = this.finalDate;
          this.finalDate = invert;
        }
        this.changeDados();
      } else {
        this.changeDados();
      }
    },

    searchTime() { 
      var self = this; 
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      } 
      this.timer = setTimeout(function () {
        self.changeDados()
      }, 1000); 
    },
 
    changeDados() {
      let initial = this.initialDate;
      if (initial) {
        initial = initial.split("/");
        initial = [initial[1], initial[0], initial[2]].join("-");
      }
      let end = this.finalDate;
      if (end) {
        end = end.split("/");
        end = [end[1], end[0], end[2]].join("-");
      }
      this.loading = true;
      this.itensPayment = [];
 
      let payload = ""

      payload += `page=${this.pageActive}`;
      payload += `&pageSize=${this.pageSize}`;
      
      if (this.status?.id) {
        payload += `&status=${this.status.id}`;
      }

      if (this.paymentsQuerySearch) {
        payload += `&reportIdOrTitle=${this.paymentsQuerySearch}`;
      }

      if (initial) {
        payload += `&initialDate=${initial}`;
      }

      if (end) {
        payload += `&finalDate=${end}`;
      }
 
      CompanyService.getPayments(payload).then(
        (response) => {
          this.loading = false;
          this.itensPayment = response.data.items;
          this.totalPages = response.data.total;
        },
        () => {
          this.loading = false;
        }
      );
    },

    convertMoney(money) {
      money = parseFloat(money);
      return money.toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL",
      });
    },
  },
};
</script>
<style>
.font-14 {
  font-size: 14px;
}
.striped:nth-of-type(odd) {
    background-color: rgba(0,0,0,.05); 
}

.multiselect__input,
.multiselect__single {
  margin-bottom: 0px !important;
  vertical-align: sub !important;
}

.multiselect {
  min-height: 38px !important;
  height: 38px !important;
}

.multiselect__tags {
  min-height: 38px !important;
}
</style>
